export const GET_BOARDS = 'GET_BOARDS'
export const GET_BOARDS_SUCCESS = 'GET_BOARDS_SUCCESS'
export const GET_BOARDS_FAILED = 'GET_BOARDS_FAILED'
export const GET_SINGLE_BOARD = 'GET_SINGLE_BOARD'
export const CREATE_CARD = 'CREATE_CARD'
export const UPDATE_CARD = 'UPDATE_CARD'
export const DELETE_CARD = 'DELETE_CARD'
export const MOVE_CARD = 'MOVE_CARD'
export const CREATE_LIST = 'CREATE_LIST'
export const EDIT_LIST_TITLE = 'EDIT_LIST_TITLE'
export const EDIT_LIST_TITLE_ON_BLUR = 'EDIT_LIST_TITLE_ON_BLUR'
export const DELETE_LIST = 'DELETE_LIST'
export const CREATE_BOARD = 'CREATE_BOARD'
export const DELETE_BOARD = 'DELETE_BOARD'
export const EDIT_BOARD = 'EDIT_BOARD'
export const SET_HOME_PROP = 'SET_HOME_PROP'